import React from "react";
import { useLocation } from "react-router-dom";
import { Loupe } from "../../../assets/img/loupe";
import { SearchInput, SearchLogo, SearchWrapper } from "./Search.styled";

export const Search = () => {
  const location = useLocation();
  let whiteText = location.pathname.includes("/collections/") || location.pathname.includes("/creators/");
  return (
    <SearchWrapper>
      <SearchInput placeholder='Seаrch..' whiteText={whiteText} />
      <SearchLogo>{Loupe()}</SearchLogo>
    </SearchWrapper>
  );
};
